<template>
     <!-- 设备列表 数据详情 -->
    <div class="main">
        <div class="tableArea">
          <div class="option">
              <div>
                <el-date-picker
                  v-model="dateRange"
                  size="small"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                  @change="changeDate"
                  clearable>
                </el-date-picker>
                <el-button @click="searchData" size="mini" type="primary" class="btnStyle"  style="margin-left: 20px">搜索</el-button>
              </div>
            </div>
            <div class="table">
              <el-table :data="tableData" style="width: 100%" :header-cell-style="{background:'#FAFAFA',color:'#405891'}" @sort-change="sortByTime">
                  <el-table-column label="序号" width="80" fixed="left">
                  <template slot-scope="scope">
                      {{scope.$index+1}}
                  </template>
                  </el-table-column>
                  <el-table-column prop="time" label="更新时间" fixed="left" sortable='custom'>
                  </el-table-column>
                  <el-table-column :prop="item.name" v-for="item,index in tableHead" :key="index" :label="item.name">
                      <template slot-scope="scope">
                          {{scope.row[item.name]}}<span style="margin-left: 5px;font-size:14px">{{item.name == 'AQI'? '': item.unit}}</span>
                      </template>
                  </el-table-column>
              </el-table>
              <div style="margin-top:0.2rem;text-align:right;">
                  <a-pagination v-model="page" :pageSize="limit"  show-quick-jumper show-size-changer :total="totalCount" @change="onChange" @showSizeChange="pageSizeChange" />
              </div>
            </div>
        </div>
  </div>
</template>

<script>
import { getDeviceLogList } from '@/api/page/deviceList.js';
export default {
  data () {
    return {
      dateRange: [this.getBeforeDate(40,'date'),this.getBeforeDate(0,'date')],
      tableData: [],
      tableHead:[],
      page:1,
      limit:10,
      totalCount:500,
      download: 0,
      maxTime:this.getBeforeDate(0,'date'),
      minTime:this.getBeforeDate(40,'date'),
      order: 1,
    }
  },
  mounted() {
    this.getDeviceLogList()
  },
  methods:{
    // 获取表格数据
   getDeviceLogList(val) {
    let self = this;
    let param = JSON.parse(this.$route.query.param)
    var data = {
        account: window.localStorage.getItem('account'),
        codes: param.code.toString(),
        datetype: 'D',
        download: this.download,
        limit: this.limit,
        min_time: this.minTime,
        max_time: this.maxTime,
        order_by_create_time: this.order,
        page: this.page,
        token: window.localStorage.getItem('token'),
        ts: this.stringTime(new Date())
      };
      getDeviceLogList(data).then(res=> {
        this.tableData = res.data.list
        this.tableHead = res.data.params
        this.totalCount = res.meta.total_count
      })

   },
  // 按照时间排序
  sortByTime(val) {
    this.order = (val.order == 'ascending'?  0:1)
    this.getDeviceLogList()
  },
  // 翻页
   onChange(val) {
    this.page = val;
    this.getDeviceLogList();
   },
   pageSizeChange(page,pageSize) {
    this.page = 1
    this.limit = pageSize
    this.getDeviceLogList()
    },
   // 搜索
   searchData() {
    if(this.isNull(this.dateRange)) {
      this.dateRange =  [this.getBeforeDate(40,'date'),this.getBeforeDate(0,'date')]
      this.maxTime=this.getBeforeDate(0,'date')
      this.minTime=this.getBeforeDate(40,'date')
      this.getDeviceLogList()
    }
    this.getDeviceLogList()
   },
   changeDate(val) {
    this.minTime = val ? val[0] || "":""
    this.maxTime = val ? val[1] || "":""
   }
  },
}
</script>

<style lang="less" scoped>
</style>
